import React from "react";

const FillDownArrow = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 9L0 0H18L9 9Z" fill={color} />
  </svg>
);

FillDownArrow.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default FillDownArrow;
